<div class="price-carousele" [ngClass.gt-sm]="'desktop'">
    <swiper fxFlex="auto" [config]="config">
        <ng-template class="custom-swiper-slide" *ngFor="let price of priceValues;let last = last;let first = first" swiperSlide>
            <div fxLayoutAlign="center center" (click)="selectPrice($event,price.value)" class="swiper-slide cursor-pointer" [ngClass]="{'first':first, 'last':last}">
              <div class="price-button"
                    fxLayoutAlign="center center"
                    [ngClass]="{'highlighted': selectedPriceValue === price.value}"
                    (click)="selectPrice($event, price.value)">
                  <div class="price-label">{{price.label}}</div>
              </div>
            </div>
        </ng-template>
    </swiper>
</div>
